import {
  FETCH_UI_CONFIG,
  FETCH_UI_CONFIG_FAILURE,
  FETCH_UI_CONFIG_SUCCESS,
  RESET_UI_CONFIG,
} from "./uiConfigTypes";

export const fetchUIConfig = () => ({
  type: FETCH_UI_CONFIG,
  payload: null,
});

export const fetchUIConfigSuccess = ({ config }) => ({
  type: FETCH_UI_CONFIG_SUCCESS,
  payload: config,
});

export const fetchUIConfigFailure = (error) => ({
  type: FETCH_UI_CONFIG_FAILURE,
  payload: error,
});

export const resetUIConfig = () => ({
  type: RESET_UI_CONFIG,
});
